<script>
    import {createEventDispatcher} from "svelte";
    import axios from "axios";
    import ChatTextBox from "./chat/ChatTextBox.svelte";
    import ChatBubbleBot from "./chat/ChatBubbleBot.svelte";
    import ChatBubbleUser from "./chat/ChatBubbleUser.svelte";
    import NewSingleFaq from './NewSingleFaq.svelte';
    
    export let data;
    export let activePerson;
    export let faqlevel;

    let chatList = [{id: 1, botText: "Hello, how can I help you?" , userText: ""},];
    let faqs = [];
    let returned = '';
    let isSolved = false;

    const dispatch = createEventDispatcher();    

    async function  setVal(v){       
        if(v.detail.trim() == '')
            return;
        let text = v.detail;
        let param = {
            search: v.detail.trim(),
        };
        if(faqlevel === "business"){
            param["business"] = data.id;
        }else if(faqlevel === "whatsapp"){
            param["whatsapp"] = activePerson.id;
        }
        await axios
        .post("process.env.MY_HOST" + "/api/searchfaqs", param)
        .then((response) => {
            faqs = response.data;
            if(faqs.length > 0){
                isSolved = true;
            }
        })
        .catch((error) => {
            console.log(error);
        });   

        chatList[chatList.length - 1].userText =  text;
        if(!isSolved){
            chatList.push({id:chatList.length + 1, botText: "Sorry, Idon't have an answer for that, what else can I help you with?", userText:""});   
        }        
    }

    function bottomBorder(i){
      return i < faqs.length - 1?"bottom-border":"";
    }

    function clear(){
        chatList = [{id: 1, botText: "Hello, how can I help you?" , userText: ""},];
        faqs = [];
        returned = '';
        isSolved = false;
    }
    function close(){
        dispatch('problem-solved');  
    }
</script>

<div  class="whatsapp-chat-panel">

    <div on:click={close} class="close-chatwith">
        <svg aria-hidden="true" focusable="false"  data-icon="times"  role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 352 512"><path fill="#333" d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"></path></svg>
    </div>

    <div  class="whatsapp-messages">
        {#each chatList as element, i (element.id)}  
        <div class="scale-in-left">                     
            <ChatBubbleBot   text={element.botText} />
        </div>       
        {#if element.userText !== ''}
        <div class="scale-in-right">
            <ChatBubbleUser   bubbleData={{val:element.userText}} />
        </div>  
        {/if}       
        {/each}
    </div>
    <div class="whatsapp-faqs-content" style="display:{isSolved?"block":"none"};">
        {#each faqs as faq, i}
        <div class={bottomBorder(i)}>
            <NewSingleFaq activeFaq="{true}" color="{data.color}" faq="{faq}" allowToggle="{true}"/>
        </div>
        {/each}
    </div>
    {#if isSolved}
    <div class="new-buttons">
        <div>
            <p on:click={clear}>           
                Next question           
            </p>
        </div>        
        {#if activePerson.online === true}
        <div on:click={() => {dispatch('problem-not-solved')}} style="background:{data.color};"
            class="button whatsapp-button">
          <img
            class="chatwith-img"
            alt="tochat-whatsapp"
            src={"https://widget.tochat.be/icon-1.png"}
          />
          <span>
            WhatsApp
          </span>
        </div>
        {:else}
        <div on:click={() => {dispatch('leave-message')}}
            style="background:{data.color};color:white;" class="button">
            {#if (data.leaveMessage)}
                {data.leaveMessage}
            {:else}
                Leave a message
            {/if}
        </div>
        {/if}
    </div>
    {:else}
    <div class="whatsapp-fix-to-bottom">
        <ChatTextBox on:message={setVal} />
    </div>    
    {/if}
</div>

<style>
    .bottom-border{
        margin-bottom:10px;
    }

    .whatsapp-faqs-content {
        padding: 5px 5px;
        border: #efefef 1px solid;
        border-radius: 5px;
        cursor:pointer;
        max-height: 400px;
        overflow-y: auto;
    }
    .whatsapp-chat-panel{
        min-height: 200px;
        padding-top: 5px;
        background: #f0f0f0;
        position: relative;
        overflow-y: auto;
        padding: 10px;
        color: #5c5b5b;
    }

    .whatsapp-chat-panel svg{
        width: 12px;
    }

    .whatsapp-fix-to-bottom{
        position: absolute;
        bottom:0;
        left:0;
        right:0;
        background: #f7f7f7;
    }

    .new-buttons{
        margin-top:10px;
        padding-top:10px;
        display:flex;
        align-items: center;
        cursor:pointer;
    }
    .new-buttons p{
        font-weight: bold;
        font-size: 14px;
        color: black;
        flex:1;
        text-align: center;
        border-radius: 5px;
        border: 2px solid black;
        padding: 9px 4px;
        margin-right: 10px;
    }
    .new-buttons .button {
        /* width: 100%; */
        text-align: center;
        padding: 5px;
        box-sizing: border-box;
        border-radius: 5px;
    }
    .new-buttons .whatsapp-button{
        color:white;
        display:flex;
        align-items: center;
        justify-content: center;
        flex:1;
    }
    .new-buttons .chatwith-img {
        height: 25px;
        width: 25px;
        display: block;
        margin-left: -3px;
        margin-bottom:3px;
    }

    .whatsapp-messages{
        margin-bottom: 40px;
        /* padding-bottom: 60px; */
        max-height: 400px;
        overflow-y: auto;
    }


    .scale-in-left {
        -webkit-animation: scale-in-left 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
        animation: scale-in-left 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
        animation-delay: 1s;
    }

    /* ----------------------------------------------
 * Generated by Animista on 2021-9-9 18:4:24
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info.
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

    /**
     * ----------------------------------------
     * animation scale-in-left
     * ----------------------------------------
     */
    @-webkit-keyframes scale-in-left {
        0% {
            -webkit-transform: scale(0);
            transform: scale(0);
            -webkit-transform-origin: 0% 50%;
            transform-origin: 0% 50%;
            opacity: 1;
        }
        100% {
            -webkit-transform: scale(1);
            transform: scale(1);
            -webkit-transform-origin: 0% 50%;
            transform-origin: 0% 50%;
            opacity: 1;
        }
    }
    @keyframes scale-in-left {
        0% {
            -webkit-transform: scale(0);
            transform: scale(0);
            -webkit-transform-origin: 0% 50%;
            transform-origin: 0% 50%;
            opacity: 1;
        }
        100% {
            -webkit-transform: scale(1);
            transform: scale(1);
            -webkit-transform-origin: 0% 50%;
            transform-origin: 0% 50%;
            opacity: 1;
        }
    }

    .scale-in-right {
        -webkit-animation: scale-in-right 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
        animation: scale-in-right 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
        margin-bottom:5px;
    }

    /* ----------------------------------------------
 * Generated by Animista on 2021-9-9 18:5:31
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info.
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

    /**
     * ----------------------------------------
     * animation scale-in-right
     * ----------------------------------------
     */
    @-webkit-keyframes scale-in-right {
        0% {
            -webkit-transform: scale(0);
            transform: scale(0);
            -webkit-transform-origin: 100% 50%;
            transform-origin: 100% 50%;
            opacity: 1;
        }
        100% {
            -webkit-transform: scale(1);
            transform: scale(1);
            -webkit-transform-origin: 100% 50%;
            transform-origin: 100% 50%;
            opacity: 1;
        }
    }
    @keyframes scale-in-right {
        0% {
            -webkit-transform: scale(0);
            transform: scale(0);
            -webkit-transform-origin: 100% 50%;
            transform-origin: 100% 50%;
            opacity: 1;
        }
        100% {
            -webkit-transform: scale(1);
            transform: scale(1);
            -webkit-transform-origin: 100% 50%;
            transform-origin: 100% 50%;
            opacity: 1;
        }
    }

    .close-chatwith{
        position: relative;
        z-index: 100;
    }

    .close-chatwith svg{
        position: absolute;
        right:12px;top:0px
    }

</style>
